import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";

import CustomerService from "../../services/customerService";

import ResponsiveDataComponent from "../common/ResponsiveDataComponent";
import Loading from "../common/Loading";
import TableActions from "../common/TableActions";
import { PhoneNumber as phoneNumber } from "../../helpers";

class CustomerList extends Component {
  constructor(props) {
    super(props);
    this.state = { customers: [], pages: 1, loading: false };
  }

  componentDidMount = () => {
    this.setState({ loading: true });
  };

  fetchData = async (state) => {
    const { pageSize, page, sorted, columns } = state;
    let { filtered } = this.props;
    filtered = columns
      .filter((col) => col.Header)
      .map((col) => ({ id: col.accessor, value: filtered }));

    const { customers, pages, totalResults } =
      await CustomerService.loadCustomers({
        pageSize,
        page,
        sorted,
        filtered
      });

    this.props.setTotalResults(totalResults);

    this.setState({ customers, pages, loading: false });
  };

  render() {
    const {
      onClickView,
      isMobile,
      filtered,
      onPageSizeChange,
      defaultPageSize
    } = this.props;
    const { customers, pages, loading } = this.state;

    const columns = !isMobile
      ? [
          { Header: "ID", accessor: "number" },
          { Header: "Name", accessor: "name" },
          { Header: "City", accessor: "address.city" },
          { Header: "State", accessor: "address.state.label" },
          { Header: "Zip", accessor: "address.zip" },
          {
            Header: "Phone",
            accessor: "phone",
            Cell: ({ value }) => phoneNumber(value)
          }
        ]
      : [{ Header: "Name", accessor: "name" }];

    columns.push({
      accessor: "_id",
      maxWidth: 80,
      sortable: false,
      Cell: (row) => (
        <TableActions
          onClickView={() => onClickView(row.value)}
          // can not delete customrs
          // onClickDelete={() => onClickDelete(row.value)}
        />
      )
    });

    const props = {
      getTdProps: (state, rowInfo, column) => {
        if (!column.expander && rowInfo?.original?._id) {
          return {
            onClick: () =>
              column.id !== "_id" && onClickView(rowInfo.original._id)
          };
        }
        return {};
      }
    };

    return (
      <ReactTable
        {...props}
        ref={(r) => (this.table = r)}
        className="-highlight"
        pages={pages}
        data={customers}
        columns={columns}
        defaultPageSize={defaultPageSize}
        onPageSizeChange={onPageSizeChange}
        noDataText="No customers found"
        LoadingComponent={() => <Loading active={loading} />}
        showPageSizeOptions={!isMobile}
        onFetchData={this.fetchData}
        filtered={filtered}
        manual
        SubComponent={
          isMobile
            ? ({ original }) => (
                <ResponsiveDataComponent
                  data={[
                    { key: "ID", label: original.number },
                    { key: "City", label: original.address.city },
                    { key: "State", label: original.address.state.value },
                    { key: "Zip", label: original.address.zip },
                    { key: "Phone", label: phoneNumber(original.phone) }
                  ]}
                />
              )
            : false
        }
      />
    );
  }
}

CustomerList.propTypes = {
  onClickView: PropTypes.func.isRequired,
  onClickDelete: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  filtered: PropTypes.string,
  defaultPageSize: PropTypes.number,
  onPageSizeChange: PropTypes.func,
  setTotalResults: PropTypes.func
};

CustomerList.defaultProps = {
  defaultPageSize: 10
};
export default CustomerList;
